import PropTypes from 'prop-types';
import React from 'react';
import OnsitePing from './onsite_ping';

class ReadersPing extends OnsitePing {
  getTitle() {
    return 'READERS UPDATE';
  }

  getBody() {
    if (this.props.overlapType === 'work_overlap') {
      return this.getWorkOverlapBody();
    } else {
      return this.getFollowOverlapBody();
    }
  }

  getWorkOverlapBody() {
    let article = $h.aOrAn(this.props.researchInterestName);
    article = article.charAt(0).toUpperCase() + article.slice(1);

    return (
      <div className="text">
        {article} <strong>{this.props.researchInterestName}</strong> researcher
        read your paper <strong>{this.props.workTitle}</strong>.
      </div>
    );
  }

  getFollowOverlapBody() {
    return (
      <div className="text">
        A reader interested in{' '}
        <strong>{this.props.researchInterestName}</strong> read your paper{' '}
        <strong>{this.props.workTitle}</strong>.
      </div>
    );
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'readers',
      trigger: 'readers-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.readers_path()),
    });
  }

  getButtonText() {
    return 'View Your Readers';
  }

  getIconClassName() {
    return 'fa fa-bell-o fa-lg icon';
  }
}

ReadersPing.propTypes = {
  overlapType: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
  workTitle: PropTypes.string.isRequired,
};

export default ReadersPing;
